<template>
  <div class="relative">
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="kreditgenie-text-green hover:kreditgenie-text-green-hover" :href="route('pages')">Seiten</inertia-link>
      <span class="kreditgenie-text-green font-medium">/</span> Schaffen
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.title" :error="form.errors.title" class="pr-6 pb-8 w-full lg:w-full" label="Titel" />

          <quill-editor
            ref="myQuillEditor"
            v-model="form.content"
            :error="form.errors.content"
            class="pr-6 pb-8 mb-8 w-full lg:w-full"
            label="Inhalt"
          />

          <text-input v-model="form.seo_title" :error="form.errors.seo_title" class="pr-6 pb-8 w-full lg:w-full" label="SEO Title" />
          <text-input v-model="form.meta_keywords" :error="form.errors.meta_keywords" class="pr-6 pb-8 w-full lg:w-full" label="Meta keywords" />
          <text-input v-model="form.meta_description" :error="form.errors.meta_description" class="pr-6 pb-8 w-full lg:w-full" label="Meta description" />

          <select-input v-model="form.status" :error="form.errors.status" class="pr-6 pb-8 w-full lg:w-1/2" label="Status">
            <option value="draft" selected>Entwurf</option>
            <option value="publish">Veröffentlichen</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <!--          <p class="btn-green kreditgenie-bg-green mr-1 cursor-pointer" @click.prevent="optionsModal">+ Add block</p>-->
          <loading-button :loading="form.processing" class="btn-green" type="submit">Speichern</loading-button>
        </div>
      </form>
    </div>
    <div v-if="showOptionsModal" class="
    z-50
    bg-black
    bg-opacity-20
    top-0
    left-0
     h-screen
      w-full
      absolute
       items-center
        justify-center
         flex
          bg-modal" @click.self="showOptionsModal = !showOptionsModal"
    >
      <div class="bg-white rounded shadow p-8 m-4 max-w-xl max-h-full text-center">
        <div class="mb-4">
          <h1>Bitte wählen Sie einen Artikeltyp aus, den Sie hinzufügen möchten</h1>
        </div>
        <div class="mb-8">
          <select-input v-model="inputItemType" class="w-full pt-2" label="Input item type">
            <option value="textField" selected>Text field</option>
            <option value="textarea">Textarea</option>
            <option value="image">Image</option>
            <option value="container">Container</option>
            <option value="widget">Widget</option>
          </select-input>
        </div>
        <div class="flex justify-center">
          <button class="flex-no-shrink text-white mr-2 py-2 px-4 rounded bg-orange-400 hover:bg-teal-dark">Cancel</button>
          <button class="flex-no-shrink text-white py-2 px-4 rounded kreditgenie-bg-green hover:bg-teal-dark">Add</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import TextInput from '@/Shared/TextInput'
import SelectInput from '../../Shared/SelectInput'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'

export default {
  metaInfo: { title: 'Create Page' },
  components: {
    quillEditor,
    SelectInput,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  props: {
    tinyMceApiKey: String,
  },
  data() {
    const documentObj = document
    const fileReader = new FileReader()
    const showOptionsModal = false
    const  inputItemType = false
    return {
      documentObj,
      fileReader,
      showOptionsModal,
      inputItemType,
      form: this.$inertia.form({
        title: null,
        content: null,
        seo_title: null,
        meta_keywords: null,
        meta_description: null,
        status: null,
      }),
    }
  },
  created() {
  },
  methods: {
    optionsModal() {
      this.showOptionsModal = !this.showOptionsModal
    },
    store() {
      this.form.post(this.route('pages.store'))
    },
  },
}

</script>

